import React from "react";

export default function RefundPolicy() {
  return (
   <div className="refund-policy-container">
  <style>
    {`
      .refund-policy-container {
        background-color: white;
        color: black;
        min-height: 100vh;
        display: flex;
        justify-content: center;
        padding: 50px 200px;
        text-align: left;
        width:100%;
      }

      .refund-policy-content {
        width: 100%;
        max-width: 900px;
      }

      .refund-policy-content h1 {
       font-size: 28px;
      font-weight: bold;
      color: black;
      margin: 0;
      }

      .refund-policy-content h4 {
        font-size: 1.2rem;
        font-weight: 600;
        margin-top: 20px;
        margin-bottom: 8px;
        line-Height:0.8;
      }

      .refund-policy-content p {
        font-size: 1rem;
        line-height: 1.6;
        margin-top: -5px;
        margin-bottom: 10px;
      }

      .refund-policy-content ul {
        list-style-type: disc;
        padding-left: 25px;
        margin-top: -5px;
        margin-bottom: 10px;
      }

      .refund-policy-content li {
        margin-bottom: 5px;
        line-height: 1.5;
      }

      @media (max-width: 1024px) {
        .refund-policy-container {
          padding: 40px 80px;
        }
      }

      @media (max-width: 768px) {
        .refund-policy-container {
          padding: 30px 30px;
        }

        .refund-policy-content h1 {
          font-size: 1.6rem;
        }

        .refund-policy-content h4 {
          font-size: 1rem;
        }

        .refund-policy-content p,
        .refund-policy-content li {
          font-size: 0.75rem;
        }
      }
    `}
  </style>

  <div className="refund-policy-content" style={{lineHeight:1}}>
    <h1>💰 Refund Policy</h1>

    <h4>1. General</h4>
    <p>
      We strive to provide the best service. This Refund Policy explains the
      conditions under which you may be eligible for a refund for any payments
      made through our platform.
    </p>

    <h4>2. Eligibility</h4>
    <p>
    <ul>
      <li>Refunds are considered only for canceled or failed orders.</li>
      <li>Refunds are not applicable for completed orders or services delivered successfully.</li>
      <li>Requests must be submitted within 30 days of the order date.</li>
    </ul>
      </p>
    <h4>3. Process</h4>
    <p>
      To request a refund, please contact our support team at [Insert Support Email].
      Include your order ID, payment details, and reason for the refund.
    </p>

    <h4>4. Refund Method</h4>
    <p>
      Approved refunds will be credited back using the original payment method.
      Processing may take up to [Insert Number] business days depending on the
      payment provider.
    </p>

    <h4>5. Partial Refunds</h4>
    <p>
      In some cases, partial refunds may be offered if the order was partially
      fulfilled or if additional services were consumed.
    </p>

    <h4>6. Exceptions</h4>
    <p>Refunds will not be issued for the following:</p>
    <p>
    <ul>
      <li>Orders canceled by the customer after the delivery partner has already started the delivery.</li>
      <li>Issues caused by incorrect customer information or instructions.</li>
      <li>Any disputes not submitted within the defined timeframe.</li>
    </ul>
      </p>
    <h4>7. Changes to this Policy</h4>
    <p>
      We may update this Refund Policy from time to time. Continued use of the
      platform implies acceptance of the latest policy version.
    </p>

    <h4>8. Contact</h4>
    <p>
      For questions or concerns regarding refunds, contact us at:<br />
      admin@despatchdost.com
    </p>
  </div>
</div>

  );
}
